import {Loading} from 'components/form';
import React, {useEffect} from 'react';
import {useGallery} from 'store/gallery'

export default function Collections(props) {
   const {collections, current_collection, getList, getCollections, dispatch, collectionLoading, loading} = useGallery();
   useEffect(() => {
      if (!collections) {
         dispatch(getCollections());
      }
   }, [])
   const handleChangeCollection = (collection) => {
      if (!loading) {
         dispatch(getList(collection));
      }
   }
   return (
      <>
         <div className="w-1/6 ml-2 h-500 flex flex-col border-l-2">
            <h1 className="font-bold text-xl mx-4 text-violet-600 mb-2">دسته بندی ها</h1>
            {collectionLoading ? (<Loading/>) : (
               <ul className="w-full mt-2 p-1 ">{collections && collections.map((item, index) =>
                  <li key={`collectionItem${index}`}
                      className={`text-xs p-2 mb-1 rounded hover:shadow-md focus:shadow-md hover:bg-violet-400 cursor-pointer ${current_collection === item.collection_name ? "bg-violet-300" : ''} ${loading ? "text-gray-300" : ''}`}
                      onClick={() => handleChangeCollection(item.collection_name)}>
                     {`${item.collection_name} (${item.quantity})`}</li>)}
               </ul>
            )}
         </div>
      </>
   );
}
